<app-preloader></app-preloader>
<app-navbar *ngIf="!(location === '/coming-soon')"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location === '/coming-soon')"></app-footer>
